export const exports = {}

export default {
  exports
}
